var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounsel2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.807,
    height: 158.807,
    viewBox: "0 0 158.807 158.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M79.4,0A79.4,79.4,0,1,1,0,79.4,79.4,79.4,0,0,1,79.4,0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6",
    "data-name": 6,
    transform: "translate(-319.133 -14.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2317",
    "data-name": "Group 2317",
    transform: "translate(352.133 78.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2314",
    "data-name": "Group 2314"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    d: "M386.475,62.987,352.133,78.6l26.9,59.165,47.946-21.8L406.262,70.405Z",
    transform: "translate(-352.133 -62.987)",
    fill: "#dcdedf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    "data-name": "Path 3457",
    d: "M380.659,76.589l13.6-6.184-19.786-7.418Z",
    transform: "translate(-340.132 -62.987)",
    fill: "#ecedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3458",
    "data-name": "Path 3458",
    d: "M392.1,67.813,378.5,74l19.785,7.418Z",
    transform: "translate(-337.971 -60.395)",
    fill: "#b3b5b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2316",
    "data-name": "Group 2316",
    transform: "translate(5.077 5.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    width: 33.087,
    height: 1.786,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 0, 13.694)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    width: 33.087,
    height: 1.786,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 1.416, 16.808)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    width: 33.088,
    height: 1.786,
    transform: "translate(2.831 19.922) rotate(-24.449)",
    fill: "#b3b5b8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    width: 44.754,
    height: 2.203,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 8.294, 31.938)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    width: 44.754,
    height: 2.203,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 10.923, 37.719)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 44.754,
    height: 2.203,
    transform: "translate(13.554 43.508) rotate(-24.449)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 44.754,
    height: 2.203,
    transform: "translate(16.186 49.295) rotate(-24.449)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_895",
    "data-name": "Rectangle 895",
    width: 44.754,
    height: 2.203,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 18.817, 55.084)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_896",
    "data-name": "Rectangle 896",
    width: 44.754,
    height: 2.203,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 21.449, 60.872)",
    fill: "#b3b5b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321",
    transform: "translate(370.139 79.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2318",
    "data-name": "Group 2318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3459",
    "data-name": "Path 3459",
    d: "M398.189,63.492,363.847,79.106l26.9,59.165,47.946-21.8L417.974,70.909Z",
    transform: "translate(-363.847 -63.492)",
    fill: "#ecedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3460",
    "data-name": "Path 3460",
    d: "M392.373,77.093l13.6-6.184-19.785-7.417Z",
    transform: "translate(-351.846 -63.492)",
    fill: "#ecedee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3461",
    "data-name": "Path 3461",
    d: "M403.812,68.317l-13.6,6.184L410,81.919Z",
    transform: "translate(-349.685 -60.9)",
    fill: "#b3b5b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2320",
    "data-name": "Group 2320",
    transform: "translate(5.076 5.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2319",
    "data-name": "Group 2319",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_897",
    "data-name": "Rectangle 897",
    width: 33.087,
    height: 1.786,
    transform: "translate(0 13.694) rotate(-24.448)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    width: 33.087,
    height: 1.786,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 1.416, 16.808)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 33.087,
    height: 1.786,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 2.832, 19.922)",
    fill: "#b3b5b8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_900",
    "data-name": "Rectangle 900",
    width: 44.754,
    height: 2.203,
    transform: "translate(8.289 31.925) rotate(-24.431)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_901",
    "data-name": "Rectangle 901",
    width: 44.754,
    height: 2.203,
    transform: "translate(10.923 37.719) rotate(-24.448)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_902",
    "data-name": "Rectangle 902",
    width: 44.754,
    height: 2.203,
    transform: "translate(13.555 43.508) rotate(-24.449)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_903",
    "data-name": "Rectangle 903",
    width: 44.754,
    height: 2.203,
    transform: "translate(16.187 49.296) rotate(-24.448)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_904",
    "data-name": "Rectangle 904",
    width: 44.754,
    height: 2.203,
    transform: "translate(18.818 55.084) rotate(-24.449)",
    fill: "#b3b5b8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_905",
    "data-name": "Rectangle 905",
    width: 44.754,
    height: 2.203,
    transform: "matrix(0.91, -0.414, 0.414, 0.91, 21.45, 60.872)",
    fill: "#b3b5b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2322",
    "data-name": "Group 2322",
    transform: "translate(390.442 33.407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3462",
    "data-name": "Path 3462",
    d: "M380.2,79.492c.381-1.127.973-2.884,2.018-6.006q-2.112-.364-4.224-.732c-.063,3.294-.1,5.146-.117,6.336Z",
    transform: "translate(-376.616 -12.271)",
    fill: "#00b3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3463",
    "data-name": "Path 3463",
    d: "M382.846,39.854l1.117-6.447,7.217,4.57-.806,4.656Z",
    transform: "translate(-373.945 -33.407)",
    fill: "#00b3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3464",
    "data-name": "Path 3464",
    d: "M388.728,52.09l-8.153-1.413c-.118.815-.231,1.619-.341,2.418l8,1.385C388.4,53.69,388.565,52.9,388.728,52.09Z",
    transform: "translate(-375.347 -24.13)",
    fill: "#646567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3465",
    "data-name": "Path 3465",
    d: "M381.15,54.174c-1.094,8.414-1.917,16.673-3.36,28.768l4.631.8c2.705-11.878,4.71-19.931,6.505-28.223Z",
    transform: "translate(-376.66 -22.252)",
    fill: "#646567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3466",
    "data-name": "Path 3466",
    d: "M386.49,38.448a2.7,2.7,0,0,0-2.733.782c-1.559,1.431-2.635,4.439-3.2,8.935-1.285,8.989-3.482,20.127-3.5,20.238,0,0,3.921-1.184,3.085-6.064.555-3.159,3.38-16.555,3.408-16.687a3.29,3.29,0,0,1,.755-1.46c.274-.251.738-.51,1.6.123.709.521,1.125.384,1.348.178.9-.822-.208-4.676-.569-5.84l-.045-.148Z",
    transform: "translate(-377.055 -30.756)",
    fill: "#646567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3467",
    "data-name": "Path 3467",
    d: "M388.373,53.635l-8-1.385c-.138.993-.267,1.977-.4,2.957l7.776,1.347C387.963,55.586,388.17,54.617,388.373,53.635Z",
    transform: "translate(-375.486 -23.285)",
    fill: "#00b3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3468",
    "data-name": "Path 3468",
    d: "M392.206,38.654q-4.1-.708-8.194-1.419c-1.6,8.242-2.692,14.689-3.555,20.662l8.153,1.413C389.8,53.393,390.947,46.956,392.206,38.654Z",
    transform: "translate(-375.228 -31.351)",
    fill: "#646567"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3469",
    "data-name": "Path 3469",
    d: "M377.88,76.877a7.732,7.732,0,0,0,.035,1.486,8.023,8.023,0,0,0,.541,2.091,10.122,10.122,0,0,0,1.746-3.176C379.43,77.144,378.655,77.009,377.88,76.877Z",
    transform: "translate(-376.623 -10.057)",
    fill: "#646567"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2324",
    "data-name": "Group 2324",
    transform: "translate(390.441 104.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2323",
    "data-name": "Group 2323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    d: "M402.529,85.4l1.854,1.76a6.079,6.079,0,0,1,1.476,2.977c.066.269,1.162,2.206,1.307,2.429.075.111,2.281,2.2,2.664,2.567.1.094.243.175.221.278s-.275.292-.346.366l-.673.709c-.682.721-.315.878-.995,1.594-1.659,1.749-3.588,3.234-5.243,4.979l-1.834,1.931c-.108.115-.526.7-.681.69-.088,0-.3-.241-.374-.294a19.618,19.618,0,0,0-2.369-1.516c-.275-.117-5.669-1.334-6.195-1.751-.636-.5-1.2-1.142-1.794-1.7l-2.478-2.349c-.184-.177-.4-.346-.566-.538a2.32,2.32,0,0,1-.624-2.1,1.475,1.475,0,0,1,1.073-1.054,1.957,1.957,0,0,1,1.167.463,8.3,8.3,0,0,1,1.3,1.124c.515.526.865.578.89.374.034-.283-.529-.658-.7-.818L378.216,84.7c-.323-.307-.7-.6-.988-.941a.877.877,0,0,1-.172-.609,2.307,2.307,0,0,1,.028-.33,2.174,2.174,0,0,1,1.708-1.831,2.753,2.753,0,0,1,.3-.051.935.935,0,0,1,.755.2c.188.168.363.344.547.518.692.656,7.93,7.62,8.377,7.952.349.26.649-.1.374-.423a12.427,12.427,0,0,0-.935-.887,19.65,19.65,0,0,1-2.043-2.052c-.426-.922.509-2.181,1.416-2.383a1.753,1.753,0,0,1,1.583.506l1.2,1.142a10.187,10.187,0,0,0,.916.87c.315.226.487.054.56-.267.066-.3-1.011-1.457-1.388-1.814a2.073,2.073,0,0,1-.772-1.6,1.9,1.9,0,0,1,1.617-1.743,1.567,1.567,0,0,1,1.446.59c.417.4,1.906,2.006,2.253,1.677.155-.141-.32-.69-.455-.842a1.646,1.646,0,0,1,.015-2.227,1.91,1.91,0,0,1,1.857-.466l-.009,0a.089.089,0,0,1,.045.011.067.067,0,0,1,.032.011l.014,0,0,0C396.9,79.957,400.869,83.824,402.529,85.4Z",
    transform: "translate(-377.055 -79.625)",
    fill: "#fbc79b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_906",
    "data-name": "Rectangle 906",
    width: 16.586,
    height: 3.242,
    transform: "translate(21.423 26.046) rotate(-46.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M421.294,103.641,405.715,88.854l-14.3,15.071,9.474,8.993Z",
    transform: "translate(-369.343 -74.668)",
    fill: "#7d7e81"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M378.9,80.507l.925.8a1.419,1.419,0,0,1-1.855,2.147l-.892-.772a2.358,2.358,0,0,1,.012-.314,2.055,2.055,0,0,1,1.531-1.8A2.419,2.419,0,0,1,378.9,80.507Z",
    transform: "translate(-377.041 -79.152)",
    fill: "#dac1ae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounsel2);
export default __webpack_public_path__ + "static/media/counsel2.76d388bac9ae1c25854e06763d1688bb.svg";
export { ForwardRef as ReactComponent };